type ProductLabels = I18nMessages['search']['filters']['sfExpertise'];

// Source UUID -> existing reviewed bundle key. This map supplies translations only;
// catalog membership, hierarchy and search values always come from the API.
const PRODUCT_LABEL_KEYS: Record<string, keyof ProductLabels> = {
    '85e19ff9-ba16-4f4e-ad24-5b930f3dcd4f': 'agentforceCategory',
    'eda45bf9-e206-46ab-8b7f-0dfdba51895f': 'agentforce',
    '14883459-8e9f-4be7-8196-0d78586b5f1f': 'commerceCategory',
    '02bce414-cd44-4a9f-893d-78eb445b1f99': 'b2bCommerce',
    '36012717-be9a-4adc-81af-eb5e8958e6db': 'b2cCommerce',
    '38cebb75-8d73-41ad-bfa7-6d65afc5f093': 'commerceAI',
    'd6acb0f3-4a63-4e83-98fe-4cf29e1ec386': 'orderManagement',
    '8aaeff0b-eb33-4c3f-ac7e-c21f814995cc': 'payments',
    'ee7aeb86-34d5-4de2-a768-8c02561ba077': 'marketingCategory',
    'c08fc5f8-408b-4449-a7bc-ca1ba8ebe223': 'b2bMarketingAutomation',
    '48c947c1-c86b-46ac-a3dd-7df68c38db71': 'emailMarketingMobileAdvertising',
    '8974465c-f06f-4917-9086-9d20eaef0ed2': 'loyaltyManagement',
    '9f576262-a02f-4a4e-82ae-2a16fd81bd8c': 'marketingAnalytics',
    '864f0421-f1d2-4eed-bf7f-354a023cd8ad': 'personalization',
    '98fe107e-fefe-4afc-9aac-dee798557856': 'salesCategory',
    'ced42610-6abb-4895-8278-5d787e54885e': 'cpq',
    'e2115850-5ba4-4db0-923b-e3d13e704cd7': 'partnerCloud',
    'abb800a4-e2a8-40c7-8760-bb4e9086286d': 'revenueLifecycleManagement',
    'd368e31d-bce0-4557-b81a-74e6bf7170fe': 'salesAgents',
    '57c24f34-394b-4e22-a1b2-f71de0ea8a1c': 'salesAI',
    '4d849e8b-7ebb-4dbf-94d5-d4ddc35b760d': 'salesCloud',
    'de7f095b-32dd-46a0-8cbb-b18fcc399613': 'salesPerformanceManagement',
    '6ef7be26-f4b7-4ffb-a671-372132b78ad5': 'serviceCategory',
    '211bcd79-fea8-49c8-bdc0-f13f796e1812': 'contactCenter',
    'f23d997a-cbf8-412d-bd61-2c84111a09d4': 'customerServiceAI',
    '13313e8c-07bf-41b2-a007-bcca7118a3c4': 'customerServiceManagement',
    'b6f47d1a-e5fb-4cc3-934f-3a2ab68af968': 'fieldService',
    '5c0a5c0c-9e02-47f4-a7fb-f572d3a35721': 'serviceAnalytics',
    'b7373dc0-8ee0-4518-9aca-09032f8ebaed': 'analyticsCategory',
    'ffd4717d-d322-48a6-8307-b611259dff43': 'crmAnalytics',
    '7fe878c3-796c-4ffd-bc0c-a7c8544445e9': 'tableau',
    '2a34c9cb-94fd-4fe0-b2b2-c13cb1403732': 'tableauNext',
    'ac60cd86-1365-4de1-9f43-3a98aea37d5e': 'tableauSemantics',
    'e1a9351a-121d-4f88-aaf7-cc9eccfb375a': 'data360Category',
    '00d15eb6-286b-4256-bc91-24651d20fe43': 'data360',
    'b64aeab0-c14a-49c0-a6f5-9eb1dfd6e274': 'platformCategory',
    '969107c8-db20-431d-b151-6d6e99bd9be2': 'agentforceAIAppDevelopment',
    '9f30f064-0f8d-49f3-9d5f-2f150b0d99fa': 'artificialIntelligence',
    '8929cabe-a02f-407c-9beb-c67421ccd27b': 'dataSecurityPrivacy',
    '20f25f7b-99eb-4b0a-b27a-c33b3a63df67': 'herokuArchitect',
    'e23389a7-d7db-40d5-8e42-fc0ec012e895': 'herokuDeveloper',
    'c1734762-70ad-40b2-b873-620bb7b78bc9': 'integration',
    '9a0ef0b4-3920-4477-b5bc-7f61e12ef57a': 'mulesoftAnypoint',
    'f67ab1d0-d278-40d2-8872-84be8ac40f35': 'mulesoftAutomation',
    '04a0e521-caf2-48e3-abc4-99f6c508a0d1': 'slackCategory',
    '0fce7d20-f29e-4372-9f71-696f38211bc4': 'agentforceInSlack',
    '47d24a98-5444-4025-a5f5-0422cb97832c': 'slack',
    '614f0eb6-2da5-4460-8883-27a468a77056': 'commerce',
};

export function resolveProductCompetencyLabel(id: string, name: string, labels: ProductLabels): string {
    const key = PRODUCT_LABEL_KEYS[id];
    return (key && labels[key]) || name;
}
